<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2OaoN8/tc-custom/9781504019750.jpg?1701061352943" alt="This image is the cover for the book Edge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Edge
      </h1>
      <p class="bookDescription body article font2">
        <b>A teenage boy searches for revenge on the streets of Oakland</b><br/><br/> The battle is nearly over. The outsiders—who came to Oakland looking for excitement—are about to get back on the highway and go home. But they hurt 1 of Zach’s friends, and he can’t let that stand. He hurls a chunk of concrete at their car, starting a fight that turns into a riot. The police flood the streets with teargas, and Zach gets lost in the chaos. In the melee, he finds something someone left behind—something that will poison his life. It’s a .38 pistol, and once he picks it up, he can’t let it go.<br/>  <br/> Zach hates violence, but since he quit high school, he feels its power creeping into his life every day. When his father is shot during a robbery, Zach’s newly found pistol gives him the power to take revenge—if his heart will let him pull the trigger.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Cadnum
      </h2>
      
      <p class="authorDescription body article">Michael Cadnum is the author of 35 books for adults and young adults. His work&mdash;which includes thrillers, suspense novels, historical fiction, and books about myths and legends&mdash;has been nominated for the National Book Award (<I>The Book of the Lion</I>), the Edgar Award (<I>Calling Home&#160;</I>and&#160;<I>Breaking the Fall</I>), and the Los Angeles Times Book Prize (<I>In a Dark Wood</I>). A former National Endowment for the Arts Creative Writing Fellow, he is also the author of award-winning poetry.&#160;<I>Seize the Storm</I>&#160;(2012) is his most recent novel.<BR /> &#160;<BR /> Michael Cadnum lives in Albany, California, with a view of the Golden Gate Bridge.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7724bb04